import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import {
	PagingSearchFieldArgument,
	PagingSearchFieldArrayArgument,
} from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';

export class RoleManagerStudentSearchModel {
	uid: number;
	first_name: string;
	last_name: string;
	middle_name: string;
	preferred_name: string;
	suffix_name: string;
	maiden_name: string;
	@Transform(dateTransformer)
	birthdate: Date;
	race: string;
	ethnicity: string;
	gender: string;
	account_email: string;
	active: boolean;
	grade: string;
	institute_id: number;
	institute_type: string;
	institute_title: string;
	institute_state: string;
	@Transform(dateTransformer)
	activated_date: Date;
	@Transform(dateTransformer)
	last_enrollment_date: Date;
	currently_enrolled: boolean;
	role_assignments: string[];
}

export function RoleManagerStudentSearchModel_ClassTransform_Type() {
	return RoleManagerStudentSearchModel;
}

export class RoleManagerStudentSearchResponseModel {
	@Type(RoleManagerStudentSearchModel_ClassTransform_Type)
	results: RoleManagerStudentSearchModel[];
	count: number;
}

export interface RoleManagerStudentSearchArgument {
	uid: PagingSearchFieldArgument;
	first_name: PagingSearchFieldArgument;
	last_name: PagingSearchFieldArgument;
	middle_name: PagingSearchFieldArgument;
	suffix_name: PagingSearchFieldArgument;
	maiden_name: PagingSearchFieldArgument;
	account_email: PagingSearchFieldArgument;
	birthdate: PagingSearchFieldArgument;
	grade: PagingSearchFieldArgument;
	activated_date: PagingSearchFieldArgument;
	last_enrollment_date: PagingSearchFieldArgument;
	currently_enrolled: { value: boolean };
	role_assignments: PagingSearchFieldArgument;
	is_assigned: { value: boolean };
	institute_id: PagingSearchFieldArrayArgument;
	institute_type: PagingSearchFieldArgument;
	institute_title: PagingSearchFieldArgument;
	institute_state: PagingSearchFieldArgument;
	race: PagingSearchFieldArgument;
	ethnicity: PagingSearchFieldArgument;
	gender: PagingSearchFieldArgument;
	active: PagingSearchFieldArgument<boolean>;
}
